"use strict";

//=require ../bower_components/jquery/dist/jquery.js
//=require ../bower_components/bootstrap/dist/js/bootstrap.bundle.js

//=require smoothScrolling.js
//=require openModalSelectPlan.js
//=require contactFormSubmission.js